import { render, staticRenderFns } from "./SFilePreviews.vue?vue&type=template&id=3712016c&scoped=true&"
import script from "./SFilePreviews.vue?vue&type=script&lang=ts&"
export * from "./SFilePreviews.vue?vue&type=script&lang=ts&"
import style0 from "./SFilePreviews.vue?vue&type=style&index=0&id=3712016c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3712016c",
  null
  
)

export default component.exports